<div class="wrap">
    <h3 class="UNFAPP-ovral-acrcy-hdng">Overall Accuracy : <b>{{totalData?.accuracy | number:'1.0-2'}}%</b></h3>
    <h6 class="UNFAPP-ovral-acrcy-subhdng">{{type}} : <b>{{num_of_questions | number:'2.0'}} /
            {{totalData?.totalchapterquestion| number:'2.0'}}</b></h6>
    <span class="UNFAPP-ovral-timetaken-text"  *ngIf="alphabet?.length">Time taken per question</span>
    <div class="svgcontainerwrap">
    <div class="svgcontainer" [ngClass]="alphabet?.length ?'': 'd-flex justify-content-center align-items-center no-bar' " id="{{dynamicCntainer}}">
        <ng-container *ngIf="alphabet?.length">

            <div id="{{dynamicid}}" style="position:relative"> </div>
        </ng-container>
        <ng-container *ngIf="!alphabet?.length">
           
                <h6 class="UNFAPP-ovral-acrcy-subhdng no-answers">No {{type}} answers  </h6>
             
        </ng-container>
    </div>
    </div>
</div>